import { Color } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
/**
 * @remarks
 * This is used by the shorthand
 *
 * @internal
 */
export const parse = Color.parse;
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-color}
 * @internal
 */
export default Longhand.of(Color.current, parse, (value, style) => value.resolve(Resolver.length(style)));
//# sourceMappingURL=border-top-color.js.map